import React, { useState } from "react";
import PropTypes from "prop-types";

import TrashIcon from "core/ReusableIcons/Trash";
import DeletePhotosModal from "../PhotoUpload/DeletePhotosModal";

import { ToolbarButton } from "./styles";

const DeleteToolbarButton = ({ quantityChecked }) => {
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);

    if (quantityChecked < 1) return null;

    return (
        <>
            <ToolbarButton onClick={() => setDeleteModalIsOpen(true)}>
                <TrashIcon /> Delete Selected
            </ToolbarButton>
            <DeletePhotosModal
                isDeletePhotoModalOpen={deleteModalIsOpen}
                onClose={() => setDeleteModalIsOpen(false)}
                numPhotosToDelete={quantityChecked}
            />
        </>
    );
};

DeleteToolbarButton.propTypes = {
    quantityChecked: PropTypes.number
};

export default DeleteToolbarButton;
